import { render } from "./EditCertificateUrbanismDetail.vue?vue&type=template&id=d04173d8&scoped=true&ts=true"
import script from "./EditCertificateUrbanismDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditCertificateUrbanismDetail.ts?vue&type=script&lang=ts&external"

import "./EditCertificateUrbanismDetail.vue?vue&type=style&index=0&id=d04173d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04173d8"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QBtn,QDialog,QCard,QBar,QSpace,QTooltip,QCardSection,QLinearProgress,QField});qInstall(script, 'directives', {ClosePopup});
